import { createBlock } from './block';
import { Block, cloneBlock, Blocks } from '@chameleoncreator/creator-app';
import uuid from 'uuidv4';
import { getSId } from './utils';

export const createTopic = (name: string): Block => {
  return createBlock(
    'Topic',
    [
      createBlock('AnimationGroup', [], {
        meta: {
          subType: 'Interaction',
        },
      }),
    ],
    {
      props: {
        name: name,
        sId: getSId('topic'), // uuid(),
      },
    }
  );
};

// Returns a new block that should be saved in a setBlock
export const addInteraction = (blocks: Blocks) => (
  topic: Block,
  interaction: Block,
  position: number
): Block => {
  if (topic.type === 'Topic') {
    // console.log(blocks);
    // console.log(topic, interaction, position);

    const group = (topic.children as Block[]).find(child => {
      const block = blocks[child.id];
      return block.meta && block.meta.subType === 'Interaction';
    });

    const groupBlock = blocks[group.id];

    return addInteractionToGroup(blocks)(groupBlock, interaction, position);
  }

  return topic;
};

export const addInteractionToGroup = (blocks: Blocks) => (
  group: Block,
  interaction: Block,
  position: number
) => {
  if (!group) {
    throw new Error(
      "Interaction group missing from topic. That shouldn't happen"
    );
  }

  if (!group.meta || group.meta.subType !== 'Interaction') {
    throw new Error('Group must have a subtype of Interaction');
  }

  const nextGroup = cloneBlock(blocks[group.id]);
  (nextGroup.children as Block[]).splice(position, 0, interaction);

  return nextGroup;
};

// return a new block that needs to be set in the state
// TODO: Implement
export const removeInteractionFromGroup = (group: Block) => (
  interaction: Block
): Block => {
  if (!group) {
    throw new Error(
      "Interaction group missing from topic. That shouldn't happen"
    );
  }
  if (group.meta.subType !== 'Interaction') {
    throw new Error('Group must have a subtype of Interaction');
  }

  const nextBlock = cloneBlock(group);

  const index = (nextBlock.children as Block[]).findIndex(
    r => r.id === interaction.id
  );
  (nextBlock.children as Block[]).splice(index, 1);

  return nextBlock;
};
